// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var HtmlToPdf$ReactHooksTemplate = require("../dashboard/dashboard/htmlToPdf.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var GenerateTicket$ReactHooksTemplate = require("../general_settings/generateTicket.res.js");
var ImportEnrichment$ReactHooksTemplate = require("../general_settings/importEnrichment.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var CampaignConfiguration$ReactHooksTemplate = require("./CampaignConfiguration.res.js");

var initialState = Campaign$ReactHooksTemplate.empty();

function Campaigns(props) {
  var campaignId = props.campaignId;
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match[0];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setShowConfigurations = match$1[1];
  var showConfigurations = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setConfigEdited = match$2[1];
  var configEdited = match$2[0];
  var match$3 = React.useState(function (param) {
        return initialState;
      });
  var setCampaign = match$3[1];
  var campaign = match$3[0];
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match$4 = url.path;
  var selected;
  if (match$4) {
    switch (match$4.hd) {
      case "campaign" :
          var match$5 = match$4.tl;
          if (match$5) {
            if (match$5.hd === "reports") {
              var match$6 = match$5.tl;
              selected = match$6 && !match$6.tl ? "reports" : "";
            } else {
              var match$7 = match$5.tl;
              if (match$7) {
                switch (match$7.hd) {
                  case "anonymous_links" :
                      selected = match$7.tl ? "" : "anonymous_links";
                      break;
                  case "campaign_report" :
                      selected = match$7.tl ? "" : "Campaign Report";
                      break;
                  case "campaigns_data_field" :
                      selected = match$7.tl ? "" : "campaigns_data_field";
                      break;
                  case "data_field_reports" :
                      selected = match$7.tl ? "" : "Data Field Report";
                      break;
                  case "follow_up_survey" :
                      selected = match$7.tl ? "" : "follow_up_survey";
                      break;
                  case "import_enrichment_rules" :
                      selected = match$7.tl ? "" : "import_enrichment_rules";
                      break;
                  case "nps_trend" :
                      selected = match$7.tl ? "" : "Nps Trend";
                      break;
                  case "redirection_logics" :
                      selected = match$7.tl ? "" : "redirection_logics";
                      break;
                  case "response_mode_reports" :
                      selected = match$7.tl ? "" : "Response Mode Report";
                      break;
                  case "ticket_generation_logics" :
                      selected = match$7.tl ? "" : "ticket_generation_logics";
                      break;
                  default:
                    selected = "";
                }
              } else {
                selected = "";
              }
            }
          } else {
            selected = "";
          }
          break;
      case "campaigns" :
          var match$8 = match$4.tl;
          if (match$8) {
            var match$9 = match$8.tl;
            if (match$9) {
              switch (match$9.hd) {
                case "dashboard" :
                    selected = match$9.tl ? "" : "dashboard";
                    break;
                case "distributions" :
                    selected = match$9.tl ? "" : "distributions";
                    break;
                default:
                  selected = match$8.hd === "report_downloads" && !match$8.tl.tl ? "report_downloads" : "";
              }
            } else {
              selected = "";
            }
          } else {
            selected = "";
          }
          break;
      default:
        selected = "";
    }
  } else {
    selected = "";
  }
  var pageTitle = function (selected) {
    switch (selected) {
      case "anonymous_links" :
          return "Anonymous Links";
      case "campaigns_data_field" :
          return "Data Fields";
      case "dashboard" :
          return "Dashboard";
      case "distributions" :
          return "Distributions";
      case "follow_up_survey" :
          return "Follow Up Survey";
      case "import_enrichment_rules" :
          return "Import Enrichment Rules";
      case "redirection_logics" :
          return "Redirection Logics";
      case "ticket_generation_logics" :
          return "Ticket Generation Logics";
      default:
        return selected;
    }
  };
  React.useEffect((function (param) {
          var params = Querystringify.parse(url.search);
          var match = Js_dict.get(params, "configuration");
          if (match === "open") {
            Curry._1(setShowConfigurations, (function (param) {
                    return true;
                  }));
            RescriptReactRouter.replace("/" + Belt_List.toArray(url.path).join("/"));
          }
          
        }), [url.search]);
  React.useEffect((function (param) {
          var url = "/api/v1/campaigns/" + campaignId;
          Js_promise.$$catch((function (err) {
                  return Promise.resolve((console.log(err), undefined));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(Curry._1(setCampaign, (function (param) {
                                        return Json_decode.field("campaign", Campaign$ReactHooksTemplate.decode, json);
                                      })));
                    }), Http$ReactHooksTemplate.fetchGetJSON(url)));
        }), []);
  var onUpdate = function (campaign) {
    Curry._1(setCampaign, (function (param) {
            return campaign;
          }));
  };
  var ticketGenerationEnabled = List.exists((function (x) {
          var settings = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (settings.TAG === "GenerateTicket") {
            return GenerateTicket$ReactHooksTemplate.value(settings._0);
          } else {
            return false;
          }
        }), Campaign$ReactHooksTemplate.applicationSettings(campaign));
  var importEnrichmentSetting = List.find_opt((function (x) {
          var match = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
          if (match.TAG === "ImportEnrichment") {
            return true;
          } else {
            return false;
          }
        }), Campaign$ReactHooksTemplate.applicationSettings(campaign));
  var tmp;
  if (importEnrichmentSetting !== undefined) {
    var setting = Caml_option.valFromOption(importEnrichmentSetting);
    var importSettings = ApplicationSetting$ReactHooksTemplate.individualSetting(setting);
    tmp = importSettings.TAG === "ImportEnrichment" && ImportEnrichment$ReactHooksTemplate.value(importSettings._0) && !ApplicationSetting$ReactHooksTemplate.enforced(setting) ? JsxRuntime.jsx("a", {
            children: JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("img", {
                        className: "m-auto inline-block align-middle max-h-full\n                      max-w-full w-6 h-6 inset-0 absolute " + (
                          selected === "import_enrichment_rules" ? "filter-white" : ""
                        ),
                        title: "Import Enrichment Rules",
                        src: Image$ReactHooksTemplate.importEnrichment
                      }),
                  className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                    selected === "import_enrichment_rules" ? "bg-palatinateblue border-palatinateblue" : ""
                  )
                }),
            href: "/campaign/" + campaignId + "/import_enrichment_rules"
          }) : null;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        Curry._1(hasPermission, "ShowCampaign") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "dashboard" ? "filter-white" : ""
                                            ),
                                            title: "Campaign Dashboard",
                                            src: Image$ReactHooksTemplate.dashboard
                                          }),
                                      className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "dashboard" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/campaigns/" + campaignId + "/dashboard"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "ShowDistribution") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "distributions" ? "filter-white" : ""
                                            ),
                                            title: "Campaign Distributions",
                                            src: Image$ReactHooksTemplate.distributions
                                          }),
                                      className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "distributions" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/campaigns/" + campaignId + "/distributions"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "ShowReport") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "Campaign Report" ? "filter-white" : ""
                                            ),
                                            title: "Campaign Reports",
                                            src: Image$ReactHooksTemplate.reports
                                          }),
                                      className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "Campaign Report" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/campaign/reports/" + campaignId
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "ShowReport") ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                              selected === "report_downloads" ? "filter-white" : ""
                                            ),
                                            title: "Report Downloads",
                                            src: Image$ReactHooksTemplate.downloadBox
                                          }),
                                      className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "report_downloads" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/campaigns/report_downloads/" + campaignId
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-5 h-5 inset-0 absolute " + (
                                            selected === "anonymous_links" ? "filter-white" : ""
                                          ),
                                          title: "Anonymous Links",
                                          src: Image$ReactHooksTemplate.anonymous
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "anonymous_links" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/campaign/" + campaignId + "/anonymous_links"
                            }),
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                      max-w-full w-5 h-5 inset-0 absolute " + (
                                            selected === "campaign_data_fields" ? "filter-white" : ""
                                          ),
                                          title: "Campaign DataFields",
                                          src: Image$ReactHooksTemplate.listdown
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "campaign_data_fields" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/campaign/" + campaignId + "/campaign_data_fields"
                            }),
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                      max-w-full w-5 h-5 inset-0 absolute " + (
                                            selected === "follow_up_survey" ? "filter-white" : ""
                                          ),
                                          title: "Follow Up Survey",
                                          src: Image$ReactHooksTemplate.followup
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "follow_up_survey" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/campaign/" + campaignId + "/follow_up_survey"
                            }),
                        ticketGenerationEnabled ? JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "m-auto inline-block align-middle max-h-full\n                      max-w-full w-5 h-5 inset-0 absolute " + (
                                              selected === "ticket_generation_logics" ? "filter-white" : ""
                                            ),
                                            title: "Ticket Generation Logics",
                                            src: Image$ReactHooksTemplate.ticketLogic
                                          }),
                                      className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                        selected === "ticket_generation_logics" ? "bg-palatinateblue border-palatinateblue" : ""
                                      )
                                    }),
                                href: "/campaign/" + campaignId + "/ticket_generation_logics"
                              }) : null,
                        tmp,
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                      max-w-full w-12 h-12 inset-0 absolute " + (
                                            selected === "redirection_logics" ? "filter-white" : ""
                                          ),
                                          title: "Redirection Logics",
                                          src: Image$ReactHooksTemplate.hyperlink
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "redirection_logics" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/campaign/" + campaignId + "/redirection_logics"
                            })
                      ],
                      className: "min-h-screen w-16 bg-ghostwhite border-r border-gray-300"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("a", {
                                              children: JsxRuntime.jsx("h2", {
                                                    children: "Campaigns",
                                                    className: "hover:underline hover:underline-offset-4"
                                                  }),
                                              className: "mr-1",
                                              href: "/campaigns/all"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "mr-1 h-3 w-4 mt-1",
                                              src: Image$ReactHooksTemplate.arrowRight
                                            }),
                                        selected !== "distributions" && selected !== "report_downloads" && selected !== "reports" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                children: [
                                                  JsxRuntime.jsx("a", {
                                                        children: JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx("h2", {
                                                                    children: Campaign$ReactHooksTemplate.name(campaign),
                                                                    className: "hover:underline hover:underline-offset-4 truncate"
                                                                  }),
                                                              className: "max-w-360-px"
                                                            }),
                                                        className: "mr-1",
                                                        href: "/campaign/reports/" + campaignId
                                                      }),
                                                  JsxRuntime.jsx("img", {
                                                        className: "mr-1 h-3 w-4 mt-1",
                                                        src: Image$ReactHooksTemplate.arrowRight
                                                      }),
                                                  JsxRuntime.jsx("h2", {
                                                        children: pageTitle(selected)
                                                      })
                                                ]
                                              }) : JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("h2", {
                                                      children: Campaign$ReactHooksTemplate.name(campaign),
                                                      className: "truncate"
                                                    }),
                                                className: "max-w-360-px"
                                              })
                                      ],
                                      className: "flex items-center text-sm font-normal leading-tight\n        tracking-normal text-left"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        selected === "dashboard" ? JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("button", {
                                                      children: JsxRuntime.jsx("img", {
                                                            className: "h-16-px",
                                                            src: Image$ReactHooksTemplate.download
                                                          }),
                                                      className: "p-2 mr-4 focus:outline-none",
                                                      id: "pdf_download",
                                                      onClick: (function (param) {
                                                          var element = Belt_Option.getExn(Caml_option.nullable_to_opt(document.querySelector("#dashboard")));
                                                          HtmlToPdf$ReactHooksTemplate.generateDashboardPdf(element);
                                                        })
                                                    })
                                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                        showConfigurations && Campaign$ReactHooksTemplate.id(campaign) !== 0 ? JsxRuntime.jsx(CampaignConfiguration$ReactHooksTemplate.make, {
                                                campaign: campaign,
                                                onClose: (function (param) {
                                                    Curry._1(setShowConfigurations, (function (param) {
                                                            return false;
                                                          }));
                                                    Curry._1(setConfigEdited, (function (param) {
                                                            return false;
                                                          }));
                                                  }),
                                                onUpdate: onUpdate,
                                                onEditedChange: (function (edited) {
                                                    Curry._1(setConfigEdited, (function (param) {
                                                            return edited;
                                                          }));
                                                  })
                                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                        JsxRuntime.jsx("button", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("img", {
                                                            className: "h-14-px mr-2-px",
                                                            src: Image$ReactHooksTemplate.cogTransparent
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "Configuration"
                                                          })
                                                    ],
                                                    className: "flex gap-1 text-darkcharcoal text-xs"
                                                  }),
                                              className: "bg-white border border-gray-300 hover:border-gray-400 hover:bg-gray-50\n                shadow-sm flex rounded-lg py-2 px-3 text-xs ml-2 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                              onClick: (function (param) {
                                                  if (showConfigurations) {
                                                    if (configEdited) {
                                                      var confirmed = window.confirm("You have unsaved changes. Are you sure you want to leave without saving?");
                                                      if (confirmed) {
                                                        Curry._1(setShowConfigurations, (function (param) {
                                                                return false;
                                                              }));
                                                        return Curry._1(setConfigEdited, (function (param) {
                                                                      return false;
                                                                    }));
                                                      } else {
                                                        return ;
                                                      }
                                                    }
                                                    Curry._1(setShowConfigurations, (function (param) {
                                                            return false;
                                                          }));
                                                    return Curry._1(setConfigEdited, (function (param) {
                                                                  return false;
                                                                }));
                                                  } else {
                                                    return Curry._1(setShowConfigurations, (function (param) {
                                                                  return true;
                                                                }));
                                                  }
                                                })
                                            })
                                      ],
                                      className: "flex justify-end"
                                    })
                              ],
                              className: "flex items-center h-16 border-b border-gray-300 p-20-px justify-between"
                            }),
                        props.content
                      ],
                      className: "w-screen"
                    })
              ],
              className: "flex"
            });
}

var make = Campaigns;

exports.initialState = initialState;
exports.make = make;
/* initialState Not a pure module */
